/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest model module.
 * @module model/AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest
 * @version 1.0
 */
class AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest {
    /**
     * Constructs a new <code>AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest</code>.
     * @alias module:model/AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest
     * @param allowedNo {Array.<Number>} 
     */
    constructor(allowedNo) { 
        
        AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest.initialize(this, allowedNo);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, allowedNo) { 
        obj['allowedNo'] = allowedNo;
    }

    /**
     * Constructs a <code>AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest} obj Optional instance to populate.
     * @return {module:model/AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest} The populated <code>AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest();

            if (data.hasOwnProperty('allowedNo')) {
                obj['allowedNo'] = ApiClient.convertToType(data['allowedNo'], ['Number']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is an array
        if (!Array.isArray(data['allowedNo'])) {
            throw new Error("Expected the field `allowedNo` to be an array in the JSON data but got " + data['allowedNo']);
        }

        return true;
    }


}

AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest.RequiredProperties = ["allowedNo"];

/**
 * @member {Array.<Number>} allowedNo
 */
AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest.prototype['allowedNo'] = undefined;






export default AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest;

